module.exports = __webpack_public_path__ + "img/3ds.27bdeb6b.svg";